import { setTimeTravelDate } from 'lib/DatetimeManager';

let mtgTimeLimit;

/**
 * This file contains handy shortcut functions to be used by QA for testing or adjusting
 * of application (in lower environments, like CI)
 */
export default {
  /**
   * Use mockdate library to pretend we are using app at given date, so that `new Date()` returns this given value
   * @param {string} - mockDate
   * @example setMockDate('2018-10-31')
   */
  setMockDate: (mockDate) => {
    // Make sure to update the APP_START_TIME used by metagame so we dont refresh app and cancel out this change
    setTimeTravelDate(new Date(mockDate));
  },
  setMtgTimeLimit: (ms) => { // called with no argument resets to undefined which triggers regular MTG time limit
    mtgTimeLimit = ms;
  },
  getMtgTimeLimit: () => mtgTimeLimit,
};
